import {
  Button,
  Stack, Typography,
} from "@mui/material";
import {
  IconMessage
} from "@tabler/icons-react";
import { grey } from "@mui/material/colors";
import React, {useState} from "react";
import {LikePopoverButton} from "./like-popover-button";
import {ConversationComments} from "./conversation-comments";

export const ConversationInteractions = ({ conversation, updateConversation }) => {
  const [showComments, setShowComments] = useState(false);

  return (
    <Stack
      direction="column"
      alignItems="flex-start"
      maxWidth="sm" gap={3}
      sx={{ mx: "auto", width: "100%", pb: 5 }}
    >
      <Stack direction="row" alignItems="center" gap={1} sx={{ width: "100%" }}>
        <LikePopoverButton
          conversation={conversation}
          updateConversation={updateConversation}
        />
        <Button
          startIcon={<IconMessage size={16} />}
          sx={{ color: showComments || conversation?.comments?.length > 0 ? "info.main" : grey[700], px: 1 }}
          color={showComments ? "info" : "secondary"}
          onClick={() => setShowComments(prev => !prev)}
        >
          Comment {conversation?.comments?.length ? `(${conversation?.comments?.length})` : null}
        </Button>
      </Stack>

      {showComments && <ConversationComments conversation={conversation} updateConversation={updateConversation} />}
    </Stack>
  );
};
